export default __webpack_public_path__ + "static/media/Image_9.74b32a26.png";